export const range = (length: number) => Array.from({ length }, (_, i) => i);
export const flat = (arr: [string, any][]) => arr.flatMap(([, v]) => v);
export const removeDuplicates = (arr: any[], key?: string) =>
  arr.filter(
    (item1: any, i: number) => arr.findIndex((item2: any) => (key ? item1[key] === item2[key] : item1 === item2)) === i
  );
export const ifIncludeRemoveElseAdd = <T,>(array: T[], val: T) =>
  array.includes(val) ? array.filter((v) => v !== val) : [...array, val];
